<template>
  <div>
    <b-modal
      id="reset-password-modal"
      title="Reset your password"
      centered
    >
      <div
        id="forgot-password-input-container"
        class="form-group"
      >
        <label for="username-label">Email address</label>
        <b-form-input
          v-model="email"
          v-b-tooltip.hover
          class="form-control"
          placeholder="Your sky email address"
          :state="emailState"
          title="Press Enter to submit"
          :formatter="format"
          style="margin-bottom: 0;"
          @keyup.enter.native="clickedSendVerificationCode()"
        />
        <div
          v-show="!emailState"
          style="font-size: 10pt; color: red; margin-top: 0.5rem; margin-bottom: 1rem; text-align: left;"
        >
          Your email needs to be ending with @sky.uk, @sky.de, @sky.at or @iwedia.com
        </div>
      </div>
      <div class="form-group text-left">
        <label for="username-label">Verification code</label>
        <input
          v-model="verification_code"
          class="form-control"
          placeholder="Enter your verification code"
          type="password"
          required="true"
          autocomplete="off"
          @keyup.enter="clickedSendVerificationCode()"
        >
        <b-alert
          variant="danger"
          dismissible
          :show="showVerifCodeError"
          @dismissed="showVerifCodeError=false"
        >
          Your verification code cannot be empty
        </b-alert>
      </div>
      <div class="form-group text-left">
        <label for="username-label">New password</label>
        <input
          v-model="password"
          class="form-control"
          placeholder="8 characters min. contains special character, 0-9, A-Z, a-z"
          type="password"
          required="true"
          autocomplete="off"
          @keyup.enter="clickedSendVerificationCode()"
        >
        <b-alert
          variant="danger"
          dismissible
          :show="showPasswordError"
          @dismissed="showPasswordError=false"
        >
          Your password must be 8 characters min. abd contains special character, 0-9, A-Z, a-z
        </b-alert>
      </div>
      <div class="form-group text-left">
        <label for="username-label">Confirm password</label>
        <input
          v-model="re_password"
          class="form-control"
          placeholder="Please re-enter your password"
          type="password"
          required="true"
          autocomplete="off"
          @keyup.enter="clickedSendVerificationCode()"
        >
        <b-alert
          variant="danger"
          dismissible
          :show="showPasswordNotMatchingError"
          @dismissed="showPasswordNotMatchingError=false"
        >
          Your passwords don't match
        </b-alert>
      </div>
      <!--
		<div style="text-align: left;">
			<b-btn type="button" id="button-generate-password" @click="clickedGeneratePassword">Click to automatically generate password</b-btn>
		</div>
		-->
      <div
        slot="modal-footer"
        class="w-100"
      >
        <b-btn
          id="footer-button"
          size="xl"
          :disabled="!emailState"
          variant="primary"
          :enabled="!showLoading && emailState"
          @click="clickedSendPassword()"
        >
          <i
            v-show="showLoading"
            class="fa fa-spinner fa-spin"
          /> Send my password
        </b-btn>
      </div>
    </b-modal>
  </div>
</template>

<script>
import bModal from 'bootstrap-vue/es/components/modal/modal'
import bModalDirective from 'bootstrap-vue/es/directives/modal/modal'

import utils from '../../utils.js'

import { EVENT_RESET_PASSWORD_EMAIL } from '../../constants'

import USER_API from '../../api/user'

export default {
	props: {
		initialEmail: {
			type: String,
			required: true
		}
	},

	data () {
		return {
			email: '',
			verification_code: '',
			password: '',
			re_password: '',
			showLoading: false,
			showEmailError: false,
			showVerifCodeError: false,
			showPasswordError: false,
			showPasswordNotMatchingError: false
		}
	},

	computed: {
		emailState () {
			return utils.validateEmail(this.email)
		}
	},

	// We watch the props being changed and update the email accordingly
	watch: {
	  	initialEmail: {
	    	handler: function (initialEmail) {
	      		this.email = this.initialEmail
	    	},
	    	immediate: true
		}
	},

	methods: {
		format: function (value, event) {
			return value.toLowerCase()
		},

		clickedGeneratePassword: function () {
			console.log('this.clickedGeneratePassword : ')

			const generatedPassword = utils.generatePassword()
			this.password = generatedPassword
			this.re_password = generatedPassword

			alert('Take note of your password: ' + generatedPassword)
		},

		clickedSendPassword: function () {
			console.log('clickedSendPassword : ', this.email, this.verification_code, this.password, this.re_password)

			if (!this.showLoading) {
				this.showEmailError = false
				this.showVerifCodeError = false
				this.showPasswordError = false
				this.showPasswordNotMatchingError = false

				// Invalid Email
				if (!utils.validateEmail(this.email)) {
					this.showEmailError = true
				}
				// Code empty
				else if (this.verification_code === '') {
					this.showVerifCodeError = true
				}
				// Password don't match
				else if (this.password !== this.re_password) {
					this.showPasswordNotMatchingError = true
				}
				// Invalid password
				else if (!utils.validatePassword(this.password)) {
					this.showPasswordError = true
				}
				// Every thing fine
				else {
					console.log('clickedSendPassword All Good')

					this.showLoading = true

					const params = {
						email: this.email,
						confirmation_code: this.verification_code,
						password: this.password
					}

					const reference = this

					USER_API.reset_password(params,
						() => {
	                        reference.showLoading = false

							reference.$root.$emit('bv::hide::modal', 'reset-password-modal')

							utils.makeToast(reference.$bvToast, 'Success', 'success', 'You have successfully reseted your password')
	                        // $('#form-signin').
	                        document.getElementById('form-signin').reset()
						},
						e => {
							console.debug(e)

							reference.showLoading = false

							if (e.hasOwnProperty('response')) {
								const response = e['response']

								if (response != undefined) {
									if (response.hasOwnProperty('data')) {
										const data = response['data']

										if (data.hasOwnProperty('error')) {
											const error = data['error']
											utils.makeToast(reference.$bvToast, 'Error', 'danger', error)

											return
										}
									}
								}
							}
							utils.makeToast(reference.$bvToast, 'Error', 'danger', "A problem occured with the check of your verification code, make sure it's the correct")
						}
					)
            	}
			} else {
				console.log('clickedSendPassword already loading')
			}
		}
	}
}
</script>

<style lang="stylus" scoped>
h1
	color: green

#footer-button
	width: 100%
	padding: 0.4rem
	font-size: 14pt

#forgot-password-input-container
	text-align: left

#button-generate-password
	background: none;
	text-decoration: underline;
	color: blue;
	font-size: 12pt;

#button-generate-password:hover
	cursor: pointer;

</style>
